import { render, staticRenderFns } from "./StartFooter.vue?vue&type=template&id=35b147d2&scoped=true&"
var script = {}
import style0 from "./StartFooter.vue?vue&type=style&index=0&id=35b147d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b147d2",
  null
  
)

export default component.exports